// Marketing source icons shared by the Logins page and the status tables.

export const GoogleIcon = () => (
  <svg width="14" height="14" viewBox="0 -13 256 256" aria-hidden="true">
    <path
      fill="#FBBC04"
      d="M5.888,166.405103 L90.88,20.9 C101.676138,27.2558621 156.115862,57.3844138 164.908138,63.1135172 L79.9161379,208.627448 C70.6206897,220.906621 -5.888,185.040138 5.888,166.396276 L5.888,166.405103 Z"
    />
    <path
      fill="#4285F4"
      d="M250.084224,166.401789 L165.092224,20.9055131 C153.210293,1.13172 127.619121,-6.05393517 106.600638,5.62496138 C85.582155,17.3038579 79.182155,42.4624786 91.0640861,63.1190303 L176.056086,208.632961 C187.938017,228.397927 213.52919,235.583582 234.547672,223.904686 C254.648086,212.225789 261.966155,186.175582 250.084224,166.419444 L250.084224,166.401789 Z"
    />
    <ellipse fill="#34A853" cx="42.6637241" cy="187.924414" rx="42.6637241" ry="41.6044138" />
  </svg>
);

export const MetaIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="#0082FB"
      d="M16.0235,4.50341 C17.8529,4.3766 19.267,5.44519 20.2076,6.67737 C21.156,7.91976 21.8094,9.54336 22.1673,11.1394 C22.5251,12.7347 22.6208,14.4504 22.3239,15.9123 C22.0388,17.3161 21.2785,18.9223 19.5568,19.437 C17.9375,19.9211 16.5179,19.2167 15.5052,18.3648 C14.4894,17.5103 13.6292,16.3122 12.953,15.1885 C12.6252,14.6438 12.3272,14.0938 12.0637,13.573 C11.8001,14.0938 11.5021,14.6438 11.1743,15.1885 C10.4981,16.3122 9.63792,17.5103 8.62209,18.3648 C7.60941,19.2167 6.18982,19.9211 4.57048,19.437 C2.84884,18.9223 2.08848,17.3161 1.80341,15.9123 C1.50655,14.4504 1.60217,12.7347 1.95995,11.1394 C2.31789,9.54336 2.97134,7.91976 3.91972,6.67737 C4.86029,5.44519 6.27437,4.3766 8.10383,4.50341 C9.81996636,4.62237364 11.0674829,5.78648603 11.8446591,6.77187041 L12.0637,7.0609 L12.0637,7.0609 L12.2827156,6.77187041 C13.059814,5.78648603 14.3073182,4.62237364 16.0235,4.50341 Z M7.89637,7.49623 C7.47584,7.46708 6.92691,7.6821 6.30436,8.49766 C5.68961,9.30301 5.17981,10.4913 4.88724,11.7959 C4.59453,13.1011 4.5524,14.3747 4.74341,15.3153 C4.90819312,16.126825 5.17222414,16.4173547 5.33536471,16.5186918 L5.40276778,16.5532373 L5.42973,16.5627 C5.6624,16.6322 6.04382,16.6134 6.69089,16.0691 C7.33482,15.5274 7.99318,14.6564 8.60392,13.6416 C8.87629333,13.1890333 9.12860444,12.7252222 9.35564593,12.2790926 L9.61563301,11.7540754 L9.8493616,11.25714 L10.0548321,10.7993939 L10.2300447,10.3919447 L10.373,10.0459 C10.2165,9.73315 9.99218,9.32834 9.71032,8.92724 C9.06612,8.01052 8.42073,7.53258 7.89637,7.49623 Z M16.2309,7.49623 C15.7066,7.53258 15.0612,8.01052 14.417,8.92724 C14.1351,9.32834 13.9108,9.73315 13.7543,10.0459 L13.9809584,10.588688 L14.1715556,11.0226741 C14.2058156,11.0990422 14.2412947,11.1772747 14.2779512,11.25714 L14.511686,11.7540754 L14.7716778,12.2790926 C14.9987222,12.7252222 15.2510333,13.1890333 15.5234,13.6416 C16.1341,14.6564 16.7925,15.5274 17.4364,16.0691 C18.0372786,16.5745214 18.4090587,16.6268332 18.6454171,16.576082 L18.6976,16.5627 C18.8279,16.5237 19.1811,16.3141 19.3839,15.3153 C19.5749,14.3747 19.5328,13.1011 19.2401,11.7959 C18.9475,10.4913 18.4377,9.30301 17.8229,8.49766 C17.2004,7.6821 16.6515,7.46708 16.2309,7.49623 Z"
    />
  </svg>
);

export const OrganicIcon = () => (
  <svg width="14" height="14" viewBox="0 0 512 512" aria-hidden="true">
    <path
      fill="#5d5b5b"
      d="M476.188,24.146c-6.748-3.504-60.728,38.022-185.304,67.086C230.347,105.355,62.5,153.527,65.286,392.815 L0,431.218l20.338,35.598c63.073-40.692,236.014-120.042,409.766-323.621c0,0-26.875,134.419-334.096,311.056 c103.685,53.758,249.604,53.758,360.979-76.806C568.346,246.888,476.188,24.146,476.188,24.146z"
    />
  </svg>
);

export const AffiliateIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#7A5AF8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7" />
    <path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7" />
  </svg>
);

export const InfluencerIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#DD2590" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="9" cy="8" r="4" />
    <path d="M2 21a7 7 0 0 1 14 0" />
    <path d="m19 3 .9 1.8 2 .3-1.45 1.4.35 2-1.8-.95-1.8.95.35-2L16.1 5.1l2-.3z" fill="#DD2590" />
  </svg>
);

export const OtherSourceIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#667085" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3 11v2a1 1 0 0 0 1 1h2l5 4V6L6 10H4a1 1 0 0 0-1 1z" />
    <path d="M15.5 8.5a5 5 0 0 1 0 7" />
    <path d="M18.5 5.5a9 9 0 0 1 0 13" />
  </svg>
);

export const RepeatIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M21 12a9 9 0 1 1-3-6.7L21 8" />
    <path d="M21 3v5h-5" />
  </svg>
);

// Affiliate partners configured in Singular. To add one, add its name here.
// `match` is compared against the media source with spaces, "_" and punctuation removed,
// so "ADsphire Media", "adsphire_media" and "Adsphire" all match "adsphire".
export const AFFILIATE_PARTNERS = [
  { match: "adsphire", name: "Adsphire Media" },
  { match: "inspirelabs", name: "InspireLabs (Grab On)" },
  { match: "grabon", name: "InspireLabs (Grab On)" },
  { match: "strongmetrics", name: "StrongMetrics" },
];

const normalise = (value) => value.toLowerCase().replace(/[^a-z0-9]/g, "");

// Agency behind a sub-affiliate install, named exactly as the webhook sends it. Singular reports
// the sub-affiliate as the media source (e.g. "Virgil_Media", "flymobi") and agencies prefix
// their campaign with their name: campaign ID "Strongmetrics_VM", or — when there is no
// campaign ID — campaign name "Admattic_Flymobi". Numeric IDs ("12345_678") aren't names.
const prefixOf = (value) => {
  const text = String(value || "");
  const prefix = text.split("_")[0].trim();
  return prefix && prefix !== text && /^[a-z]{3,}/i.test(prefix) ? prefix : null;
};
const findAgency = ({ campaignId, campaignName } = {}) =>
  campaignId ? prefixOf(campaignId) : prefixOf(campaignName);

const SOURCE_TYPES = {
  google: { label: "Google Ads", Icon: GoogleIcon },
  meta: { label: "Meta Ads", Icon: MetaIcon },
  organic: { label: "Organic", Icon: OrganicIcon },
  influencer: { label: "Influencer", Icon: InfluencerIcon },
  affiliate: { label: "Affiliate", Icon: AffiliateIcon },
  other: { label: "Other partner", Icon: OtherSourceIcon },
};

// Backend source_platform is already normalised to google / meta / organic,
// otherwise it carries the raw media source (e.g. "adsphire_media").
// Unknown sources fall back to "other" and still show the raw media source on hover,
// so a new partner is visible before it is added to the lists above.
// `campaign` ({ campaignId, campaignName }) lets a sub-affiliate be shown under its agency.
export const classifySource = (source, campaign) => {
  const s = normalise(source || "");
  if (!s) return null;
  let type = "other";
  let partner = null;
  let agency = null;
  const affiliate = AFFILIATE_PARTNERS.find((p) => s.includes(p.match));
  if (s.includes("organic")) type = "organic";
  else if (s.includes("google") || s.includes("adwords")) type = "google";
  else if (s.includes("meta") || s.includes("facebook") || s.includes("instagram") || s === "fb") type = "meta";
  else if (affiliate) {
    type = "affiliate";
    partner = affiliate.name;
  } else if (s.includes("affiliate")) type = "affiliate";
  else if (s.includes("influencer") || s.includes("creator")) type = "influencer";
  if (type === "other" && (agency = findAgency(campaign))) type = "affiliate";
  return { type, partner, agency, ...SOURCE_TYPES[type] };
};
